import _get from 'lodash/get'
import Vue from 'vue'
import {TripDashboardStore} from "./_store_trip_dashboard";

export default {
  state: {
    collection: _get(window, 'appInitialData.dashboards', []),
    currentTripDashboardId: null,
    tripLogo: null
  },
  mutations: {
    switchCurrentDashboard(state, payload) {
      state.currentDashboard = parseInt(payload)
    },
    setCurrentDashboard(state, payload) {
      let newCollection = { ...state.collection }
      newCollection[payload.dashboardId] = payload.data
      Vue.set(state, 'collection', newCollection)
      Vue.set(state, 'currentTripDashboardId', parseInt(payload.dashboardId))
    },
    updateTripUsers(state, payload) {
      let newTripCollection = { ...state.collection }
      newTripCollection[state.currentTripDashboardId].users = payload
      TripDashboardStore.commit('setClientUsers', payload)
      Vue.set(state, 'collection', newTripCollection)
    },
    updateTripEventsAndTodoItems(state, payload) {
      let newTripCollection = { ...state.collection }
      newTripCollection[state.currentTripDashboardId].calendar.custom_events = payload.custom_events
      newTripCollection[state.currentTripDashboardId].events = payload.events
      newTripCollection[state.currentTripDashboardId].todo_items = payload.todo_items
      Vue.set(state, 'collection', newTripCollection)
    },
    updateTripDashboardOmitTermsAndConditionsSignature(state, payload) {
      const tripDashboard = state.collection[state.currentTripDashboardId]
      if (tripDashboard) {
        tripDashboard.omit_terms_and_conditions_signature = payload === 1
      }
    },
    updateTripLogo(state, payload) {
      Vue.set(state, 'tripLogo', payload)
    },
    addClientIfNotExists(state, user) {
      if (!Array.isArray(state.clients)) {
        state.clients = []
      }
      if (!state.clients.some(client => client.id === user.id)) {
        state.clients.push(user)
      }
    },

    removeClientsNotInList(state, remainingUserIds) {
      if (!Array.isArray(state.clients)) {
        state.clients = []
      }
      if (Array.isArray(remainingUserIds)) {
        state.clients = state.clients.filter(client => remainingUserIds.includes(client.id))
      } else {
        console.error("remainingUserIds should be an array")
      }
    }
  },
  actions: {
    setupTripResources(context, payload) {
      if (payload && payload.id) {
        context.commit('switchCurrentDashboard', payload.id)
      }
    },
    updateTripDashboardOmitTermsAndConditionsSignature(context, payload) {
      context.commit('updateTripDashboardOmitTermsAndConditionsSignature', payload)
    },
    updateTripLogo(context, payload) {
      context.commit('updateTripLogo', payload)
    }
  },
  getters: {
    // @todo refactor/rename
    Trip: (state, getters) => {
      return getters.currentTripDashboard || {}
    },
    // @todo refactor/rename
    Trips: (state, getters) => {
      return getters.tripDashboards
    },
    tripDashboards: state => state.collection,
    currentTripDashboard: state =>
      state.currentTripDashboardId ? state.collection[state.currentTripDashboardId].data : null,
    currentClientTrip: (state, getters) => {
      return getters.currentTripDashboard && getters.currentTripDashboard.trip
        ? getters.currentTripDashboard.trip
        : null
    },
    currentTripDashboardId: state => {
      return state.currentTripDashboardId
    },
    logo: state => {
      if (state.tripLogo) {
        return  state.tripLogo
      }
      if (state.currentTripDashboardId) {
        return state.collection[state.currentTripDashboardId].logo
      }
    }
  }
}
